
import { NotifyPropertyChangedBase } from "../../Utilities";
import { ICorrelation } from "../Utilities";






export class HydrationBase extends NotifyPropertyChangedBase {

    public static get DirtyHydratePropertyName() { return 'DirtyHydrate' }

    protected constructor() {
        super();

        this._hydratePromise = new Promise<void>(async (resolve) => { this._resolveFN = resolve; });
    }

    public get HydratePromise() { return this._hydratePromise; }


    public async Hydrate(correlation: ICorrelation, isRehydrate = false): Promise<void> {

        if (isRehydrate) {
            this._isHydrated = false;
            this._hydrateStarted = false;
            this.FireChanged('isHydrated');
            if (this._hydratePromise)
                await this._hydratePromise;
            this._hydratePromise = new Promise<void>(async (resolve) => { this._resolveFN = resolve; });
        }

        (async () => {
            if (!this.isHydrated && !this._hydrateStarted) {
                this._hydrateStarted = true;

                await this.doHydrateProperties(correlation, isRehydrate);
                await this.doHydrate(correlation, isRehydrate);

                this.SetHydrated();
            }
        })();
        return this._hydratePromise;
    }


    protected async doHydrate(_correlation: ICorrelation, _isRehydrate = false) {
        console.warn("doHydrate was not overridden in derived classes nor was setHydrate called in the constructor.");
    }

    /**
     * Hydrates the properties that derive from HydrationBase.
     * Override this method in classes that actually hydrate themselves.
     * @param correlation The correlation object.
     */
    private async doHydrateProperties(correlation: ICorrelation, isRehydrate = false) {
        var propertyPromises: Promise<void>[] = [];
        for (const key in this) {
            if (this[key] instanceof HydrationBase) {
                propertyPromises.push(this[key].Hydrate(correlation, isRehydrate));
            }
        }

        await Promise.all(propertyPromises);
    }

    public get isHydrated() { return this._isHydrated; }
    protected SetHydrated() {
        
        this._isHydrated = true;
        if (this._resolveFN) {
            this._resolveFN();
        }
        else {
            this._hydratePromise = Promise.resolve();
        }
        this.FireChanged('isHydrated', true);


        if (this.isDirty)
            this.FireChanged(HydrationBase.DirtyHydratePropertyName);
    }
    private _isHydrated = false;


    private _hydratePromise: Promise<void>;
    private _resolveFN?: (value?: void | PromiseLike<void> | undefined) => void;
    private _hydrateStarted = false;
}